












import { ValidationProvider } from 'vee-validate';
import { Vue, Component, VModel, Prop } from 'vue-property-decorator';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class VSelectWithValidation extends Vue {
  @VModel()
  public innerValue: any;

  @Prop({ type: [String, Object], default: '' })
  public readonly rules!: string | Object;
}
